import axios from "axios";

export default {
  name: "HelperMixin",
  data() {
    return {
      a: "",
    };
  },

  methods: {

      helperGet(action, param={}) {
          let self = this;
          let link = `${action}?${this.helperSerialize(param)}`;
          link = this.$store.getters.baseUrl + '/' + link;
          return  axios.get(link,
              {
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': 'Bearer ' + this.$store.getters.appToken
                  }
              }).
          then(function (r) {
              return r;
          }).catch(function () {
              self.$toast.error('خطای شبکه رخ داده');
          })
      },
      helperPost(action, param) {
          let self = this;
          param = typeof param == "undefined" ? {} : param;
          param.token =this.$store.getters.appToken;
          let link = this.$store.getters.baseUrl + '/' + action;
          return  axios.post(link, param, {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' +this.$store.getters.appToken
              }
          }).then( r=>{
              return r;
          }).catch( function() {
              self.$toast.error('خطای شبکه رخ داده');


          })
      },


    helperSerialize(obj) {
      return Object.keys(obj)
          .map(
              (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
          )
          .join("&");
    },


      helperGet_taxi(action, param) {

          let self = this;
          let link = action + '?' + param;
          console.log('1',self.$store.getters.baseUrl_taxi)
          link = self.$store.getters.baseUrl_taxi + '/' + link;
          return  axios.get(link,
              {
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': 'Bearer '+this.$store.getters.appToken_taxi
                  }
              }).
          then(function (r) {
              return r;
          }).catch(function () {
              // self.$toast.error('خطای شبکه رخ داده')
          })
      },
      helperPost_taxi(action, param,istoken='no') {
          // alert('tta');
          let self = this;
          param = typeof param == "undefined" ? {} : param;
          if(istoken=='no')
              param.token = +this.$store.getters.appToken_taxi;
          let link = self.$store.getters.baseUrl_taxi + '/' + action;
          return  axios.post(link, param, {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer '   +this.$store.getters.appToken_taxi
              }
          }).then( r=>{
              return r;
          }).catch( function() {
              // self.$toast.error('خطای شبکه رخ داده')
          })
      },

    helperExcerpt(str, len) {
      if (typeof str !== "string") {
        return str;
      }
      return str.length > len ? `${str.substring(0, len)}...` : str;
    },

    helperNumberFormat(number) {
      number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
      const n = !isFinite(+number) ? 0 : +number;
      const prec = 0;
      const sep = ",";
      const dec = ".";
      const toFixedFix = (n, prec) => {
        const k = Math.pow(10, prec);
        return (Math.round(n * k) / k).toFixed(prec);
      };
      let s = (prec ? toFixedFix(n, prec) : Math.round(n).toString()).split(
          "."
      );
      if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      }
      if ((s[1] || "").length < prec) {
        s[1] = s[1] || "";
        s[1] += new Array(prec - s[1].length + 1).join("0");
      }
      return s.join(dec);
    },
      formatPrice(value) {
          let val = (value/1).toFixed(0).replace('.', ',')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
  },
};
